const pt = {
  nav: {
    home: 'Início',
    suites: 'Suítes',
    history: 'História',
    experiences: 'Experiências',
    gallery: 'Galeria',
    contact: 'Contato',
    reserveNow: 'Reservar Agora'
  },
  home: {
    heroTitle: 'História Viva',
    heroSubtitle: 'em Ouro Preto',
    checkInOut: 'Check-in / Out',
    checkInPlaceholder: 'Ex: 10/05 a 15/05',
    guests: 'Hóspedes',
    promoCode: 'Cód. Promo',
    promoPlaceholder: 'Opcional',
    search: 'Pesquisar',
    privilegedLocation: 'Localização Privilegiada',
    privilegedLocationDesc: 'No coração histórico de Ouro Preto, próximo aos principais pontos turísticos',
    exceptionalService: 'Serviço Excepcional',
    exceptionalServiceDesc: 'Equipe dedicada para tornar sua estadia inesquecível',
    luxuryHistory: 'Luxo e História',
    luxuryHistoryDesc: 'Decoração que une o charme colonial com conforto moderno',
    ourAccommodations: 'Nossas Acomodações',
    ourAccommodationsDesc: 'Escolha entre nossas suítes cuidadosamente decoradas, cada uma oferecendo uma experiência única',
    viewAllSuites: 'Ver Todas as Suítes',
    readyToLiveHistory: 'Pronto para Viver História?',
    readyToLiveHistoryDesc: 'Reserve agora e garanta sua experiência inesquecível em Ouro Preto',
    person: 'Pessoa',
    people: 'Pessoas',
    morePeople: '+ Pessoas'
  },
  suites: {
    title: 'Nossas Suítes',
    description: 'Cada suíte foi cuidadosamente projetada para oferecer o máximo conforto e uma experiência única, combinando o charme histórico de Ouro Preto com comodidades modernas.',
    size: 'Tamanho',
    capacity: 'Capacidade',
    daily: 'Diária',
    viewDetails: 'Ver Detalhes',
    needHelp: 'Precisa de Ajuda para Escolher?',
    needHelpDesc: 'Nossa equipe está pronta para ajudá-lo a encontrar a suíte perfeita para sua estadia.',
    talkOnWhatsApp: 'Falar no WhatsApp',
    standard: {
      name: 'Apartamento Standard',
      subtitle: 'Conforto e Elegância',
      description: 'Nosso Apartamento Standard oferece uma experiência acolhedora com decoração que combina o charme colonial de Ouro Preto com o conforto moderno. Ideal para casais ou viajantes solo que buscam uma estadia confortável.'
    },
    junior: {
      name: 'Suíte Junior',
      subtitle: 'Espaço e Sofisticação',
      description: 'A Suíte Junior é perfeita para quem busca mais espaço e conforto. Com área ampla e decoração refinada, oferece um ambiente relaxante com toques de luxo que remetem à história de Ouro Preto.'
    },
    executiva: {
      name: 'Suíte Executiva',
      subtitle: 'Requinte e Exclusividade',
      description: 'Nossa Suíte Executiva é projetada para viajantes exigentes que valorizam conforto premium e serviços diferenciados. Com vista privilegiada e decoração elegante, é ideal para estadias prolongadas.'
    },
    master: {
      name: 'Suíte Master',
      subtitle: 'O Máximo em Luxo',
      description: 'A Suíte Master é nossa acomodação mais luxuosa e exclusiva. Com design sofisticado, espaço generoso e todas as comodidades imagináveis, proporciona uma experiência inesquecível no coração de Ouro Preto.'
    },
    backToSuites: 'Voltar para Suítes',
    startingFrom: 'A partir de',
    perNight: 'por noite',
    aboutSuite: 'Sobre a Suíte',
    amenities: 'Comodidades',
    reserveThisSuite: 'Reservar Esta Suíte',
    accommodation: 'Acomodação',
    luxury: 'Luxo'
  },
  history: {
    title: 'Nossa História',
    quote: '"No coração histórico de Ouro Preto, onde cada pedra conta uma história, a Pousada do Mondego nasce como um tributo à rica herança colonial brasileira."',
    journeyTitle: 'Uma Jornada Através do Tempo',
    journeyText1: 'Localizada no icônico Largo de Coimbra, a Pousada do Mondego ocupa um edifício que remonta ao século XVIII, período áureo do ciclo do ouro em Minas Gerais. Originalmente construída como residência de uma família portuguesa, a construção preserva elementos arquitetônicos típicos do barroco colonial.',
    journeyText2: 'Em 2016, após uma cuidadosa restauração que levou três anos, o edifício foi transformado em uma pousada boutique, mantendo sua essência histórica enquanto incorporava todas as comodidades modernas que nossos hóspedes merecem.',
    preservationTitle: 'Preservação com Paixão',
    preservationText1: 'Cada detalhe da Pousada do Mondego foi pensado para honrar a história de Ouro Preto. As paredes de pedra original foram preservadas, as portas e janelas de madeira maciça foram restauradas artesanalmente, e elementos decorativos coloniais foram integrados à decoração contemporânea.',
    preservationText2: 'A pousada dedica-se integralmente à preservação do patrimônio histórico, guiada por um compromisso profundo com a conservação da nossa herança cultural e o respeito à memória brasileira.',
    familyTitle: 'A Família Mondego',
    familyText1: 'O nome "Mondego" é uma homenagem ao Rio Mondego, que corta a cidade de Coimbra em Portugal, de onde vieram os primeiros proprietários do edifício no século XVIII. Essa conexão luso-brasileira é celebrada em cada canto da pousada.',
    familyText2: 'Hoje, a Pousada do Mondego tem uma administração familiar, que há três gerações se dedica à hospitalidade em Minas Gerais. Com amor e dedicação, continuamos a escrever novos capítulos desta história centenária.',
    timeline: 'Linha do Tempo',
    timeline1747: 'Construção do edifício original como residência colonial',
    timeline1980: 'Início do projeto de restauro cuidadoso pela família Pereira',
    timeline1988: 'Inauguração da Pousada do Mondego',
    timeline2012: 'Início do processo de restauração e adaptação',
    timeline2016: 'Reinauguração da Pousada do Mondego'
  },
  experiences: {
    title: 'Experiências',
    subtitle: 'Descubra o melhor de Ouro Preto',
    toursActivities: 'Eventos',
    toursDesc: 'Nossa equipe de concierge pode organizar experiências únicas para tornar sua estadia inesquecível',
    historicalTours: 'Passeios Históricos',
    adventureNature: 'Aventura e Natureza',
    cultureGastronomy: 'Cultura e Gastronomia',
    photography: 'Fotografia',
    events: 'Eventos',
    weddings: 'Casamentos',
    weddingsDesc: 'Realize o sonho de celebrar em um local inesquecível.',
    corporateEvents: 'Eventos Corporativos',
    corporateEventsDesc: 'Traga sua equipe para uma paisagem de tirar o fôlego.',
    customized: 'Personalizado',
    onRequest: 'Sob consulta',
    annualEvents: 'Eventos Anuais',
    annualEventsDesc: 'Ouro Preto é palco de eventos culturais ao longo do ano todo',
    customizeExperience: 'Personalize Sua Experiência',
    customizeDesc: 'Entre em contato com nossa equipe de concierge para criar um roteiro personalizado.',
    talkToConcierge: 'Falar com Concierge',
    duration: 'Duração',
    price: 'Preço',
    annualEventsList: {
      anniversary: { name: 'Aniversário de Ouro Preto', month: '08 de Julho', description: 'Feriado municipal.' },
      gastronomicFestival: { name: 'Festival Gastronômico', month: 'Julho', description: 'Celebração da culinária mineira com menus especiais nos restaurantes locais.' },
      corpusChristi: { name: 'Corpus Christi', month: 'Maio/Junho', description: 'Feriado nacional.' },
      holyWeek: { name: 'Semana Santa', month: 'Março/Abril', description: 'Celebrações religiosas tradicionais com procissões e tapetes coloridos nas ruas.' },
      tiradentes: { name: 'Tiradentes', month: '21 de Abril', description: 'Feriado nacional, data magna ligada à Inconfidência Mineira.' },
      laborDay: { name: 'Dia do Trabalhador', month: '01 de Maio', description: 'Feriado nacional.' },
      independence: { name: 'Independência do Brasil', month: '07 de Setembro', description: 'Feriado nacional.' },
      aparecida: { name: 'Nossa Senhora Aparecida', month: '12 de Outubro', description: 'Feriado nacional e festa nas repúblicas de Ouro Preto.' },
      finados: { name: 'Finados', month: '02 de Novembro', description: 'Feriado nacional.' },
      republicProclamation: { name: 'Proclamação da República', month: '15 de Novembro', description: 'Feriado nacional.' },
      blackConsciousness: { name: 'Dia Nacional de Zumbi e da Consciência Negra', month: '20 de Novembro', description: 'Feriado nacional.' }
    }
  },
  gallery: {
    title: 'Galeria',
    description: 'Explore a beleza e o conforto da Pousada do Mondego através de nossa galeria de imagens',
    categories: {
      facade: 'Fachada e Exterior',
      diner: 'Jantar Especial',
      standard: 'Apartamento Standard',
      junior: 'Suíte Junior',
      executive: 'Suíte Executiva',
      master: 'Suíte Master',
      common: 'Áreas Comuns',
      details: 'Detalhes',
      media: 'Mondego na Mídia',
      breakfast: 'Café da Manhã'
    }
  },
  contact: {
    title: 'Contato',
    subtitle: 'Estamos aqui para ajudá-lo',
    getInTouch: 'Entre em Contato',
    getInTouchDesc: 'Nossa equipe está pronta para atendê-lo e tornar sua experiência na Pousada do Mondego inesquecível.',
    address: 'Endereço',
    phone: 'Telefone',
    whatsappContact: 'WhatsApp',
    whatsappAvailable: 'WhatsApp disponível',
    email: 'E-mail',
    serviceHours: 'Horário de Atendimento',
    mondayToFriday: 'Segunda a Sexta',
    saturday: 'Sábado',
    sundaysHolidays: 'Domingos e Feriados',
    closed: 'Fechado',
    socialMedia: 'Redes Sociais',
    sendMessage: 'Envie uma Mensagem',
    fullName: 'Nome Completo',
    yourName: 'Seu nome',
    yourEmail: 'seu@email.com',
    message: 'Mensagem',
    howCanWeHelp: 'Como podemos ajudá-lo?',
    sendButton: 'Enviar Mensagem',
    messageSent: 'Mensagem Enviada!',
    willReturnSoon: 'Retornaremos em breve.',
    ourLocation: 'Nossa Localização',
    checkIn: 'Check-in: 14h',
    checkOut: 'Check-out: 12h',
    breakfastIncluded: 'Café da manhã incluso',
    freeWifi: 'WiFi gratuito',
    freeParking: 'Estacionamento gratuito'
  },
  footer: {
    description: 'Uma experiência única de hospedagem no coração histórico de Ouro Preto.',
    quickLinks: 'Links Rápidos',
    information: 'Informações',
    copyright: 'Todos os direitos reservados.'
  },
  whatsapp: {
    hello: 'Olá! 👋 Gostaria de solicitar um orçamento para o *Pousada do Mondego*:',
    period: '📅 *Período:*',
    guests: '👥 *Quantidade de Hóspedes:*',
    code: '🎟️ *Código:*',
    checkAvailability: 'Poderiam verificar a disponibilidade, por favor?',
    reserveSuite: 'Olá! 👋 Gostaria de fazer uma reserva da *{suite}*. Poderiam me enviar mais informações?',
    helpChoosing: 'Olá! Gostaria de ajuda para escolher uma suíte.',
    experiencesInfo: 'Olá! Gostaria de informações sobre passeios e experiências.',
    newMessage: '*Nova Mensagem do Site*',
    name: '*Nome:*',
    phone: '*Telefone:*',
    toArrange: 'A combinar'
  }
};

export default pt;
